import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
    const tabsSwiperEl = document.querySelector('.js-services-tabs-swiper');

    if (!tabsSwiperEl) return;

    const tabsSwiper = new Swiper(tabsSwiperEl, {
        modules: [Navigation],
        slidesPerView: 2.5,  // You can adjust this value based on your design
        spaceBetween: 20,
        loop: false,
        navigation: {
            nextEl: '.js-services-tabs-swiper .swiper-button-next',
            prevEl: '.js-services-tabs-swiper .swiper-button-prev',
        },
        breakpoints: {
            992: {
                slidesPerView: 3, // Adjust to show 3 items on larger screens
                spaceBetween: 60
            },
            576: {
                slidesPerView: 1, // Show 1 item per slide on mobile
                spaceBetween: 10
            }
        }
    });

    if (document.querySelector('.section-our-services-block__button')) {
        const block = document.querySelector('.section-our-services-block');
        const buttons = block.querySelectorAll('.section-our-services-block__button');
        const contents = block.querySelectorAll('.section-our-services-block__tab-content');

        buttons.forEach((button, index) => {
            button.addEventListener('click', () => {
                // Deactivate all buttons
                buttons.forEach(btn => btn.classList.remove('is-active'));
                // Hide all tab contents
                contents.forEach(content => content.classList.remove('is-visible'));

                // Activate the clicked button
                button.classList.add('is-active');
                // Show the corresponding tab content within the block
                const tabId = button.getAttribute('data-tab');
                const tabContent = block.querySelector(`#${tabId}`); // Scoped to the block
                if (tabContent) {
                    tabContent.classList.add('is-visible');
                }
            });
        });
    }
});
if(document.querySelectorAll(".section-our-services-block__details")) {
    document.querySelectorAll(".section-our-services-block__details").forEach(details => {
        const extraTiles = details.querySelectorAll(".section-our-services-block__extra-tile");

        if (extraTiles.length === 1) {
            extraTiles[0].style.width = "98.5%";
        }
    });
}